


































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ConfigurationItem from "@/components/ConfigurationItem.vue";
import ItemGroupOption from "@/components/ItemGroupOption.vue";
import { IItemParams } from "@/models/itemParams";
import { ItemSectionOption } from "@/models/itemSectionOption";

@Component({
  components: {
    ConfigurationItem,
    ItemGroupOption,
  },
})
export default class ConfigurationItemGroup extends Vue {
  @Prop({ type: Array, required: true }) params!: IItemParams[];
  @Prop({ type: Array, required: false, default: () => [] })
  options!: ItemSectionOption[];

  private wasDisabledClick: boolean = false;

  mounted() {
    if (this.options.length) {
      this.options[0].isSelected = true;
    }
  }

  private onItemSelected(params: IItemParams) {
    // hook
  }

  private onOptionSelected(option: ItemSectionOption) {
    this.options.forEach((x) => (x.isSelected = false));
    option.isSelected = true;
  }

  private onMouseOver(params: IItemParams) {
    this.params.forEach((x) => (x.isPopoverOpen = false));
    params.isPopoverOpen = true;
  }

  private onMouseLeave(params: IItemParams) {
    this.params.forEach((x) => (x.isPopoverOpen = false));
  }
}
